export const profile = {
  'profile.theClubUserProfile.title': 'Profilo Utente del Club',
  'profile.theClubUserProfile.userStatus': 'Stato Utente',
  'profile.theClubUserProfile.username': 'Nome Utente',
  'profile.theClubUserProfile.memberSince': 'Membro da',
  'profile.theClubUserProfile.sponsor': 'Sponsor',
  'profile.theClubUserProfile.referralLink': 'Link di Referral',
  'profile.theClubUserProfile.commissionModel': 'Modello di Commissione',
  'profile.theClubUserProfile.commissionLevels': 'Livelli di Commissione',
  'profile.theClubUserProfile.commissionlevel': 'Livello',
  'profile.theClubUserProfile.rank': 'Rango',
  'profile.theClubUserProfile.copyTooltip': 'Copiato negli appunti!',
  'profile.theClubUserProfile.copyReferralLink': 'Copia link di referral',
  'profile.theClubUserProfile.userInformation': 'Informazioni Utente',
  'profile.personalInformation.title': 'Le Mie Informazioni Personali',
  'profile.personalInformation.firstName': 'Nome',
  'profile.personalInformation.lastName': 'Cognome',
  'profile.personalInformation.email': 'Email',
  'profile.personalInformation.phone': 'Telefono',
  'profile.personalInformation.dateOfBirth': 'Data di Nascita',
  'profile.personalInformation.gender': 'Genere',
  'profile.personalInformation.country': 'Paese',
  'profile.personalInformation.address': 'Indirizzo',
  'profile.personalInformation.city': 'Città',
  'profile.personalInformation.postalCode': 'Codice Postale',
  'profile.personalInformation.edit': 'Modifica',
  'profile.personalInformation.save': 'Salva',
  'profile.personalInformation.cancel': 'Annulla',
  'profile.personalInformation.male': 'Maschio',
  'profile.personalInformation.female': 'Femmina',
  'profile.personalInformation.other': 'Altro',
  'profile.personalInformation.saving': 'Salvataggio...',
  'profile.personalInformation.selectGender': 'Seleziona genere',
  'profile.personalInformation.saveChanges': 'Salva modifiche',
  'profile.paymentMethods.title': 'I Miei Metodi di Pagamento',
  'profile.paymentMethods.cryptoWallet': 'Portafoglio Crypto',
  'profile.paymentMethods.bankAccount': 'Conto Bancario',
  'profile.paymentMethods.network': 'Rete',
  'profile.paymentMethods.currency': 'Valuta',
  'profile.paymentMethods.address': 'Indirizzo',
  'profile.paymentMethods.accountNumber': 'Numero di Conto',
  'profile.paymentMethods.routingNumber': 'Numero di Routing',
  'profile.paymentMethods.bankName': 'Nome Banca',
  'profile.paymentMethods.accountHolderName': 'Nome Intestatario',
  'profile.paymentMethods.swiftCode': 'Codice SWIFT',
  'profile.paymentMethods.edit': 'Modifica',
  'profile.paymentMethods.save': 'Salva',
  'profile.paymentMethods.cancel': 'Annulla',
  'profile.paymentMethods.cryptoWalletHeader': 'Portafoglio Criptovalute',
  'profile.paymentMethods.bankAccountHeader': 'Dettagli Conto Bancario',
  'profile.paymentMethods.selectNetwork': 'Seleziona rete',
  'profile.paymentMethods.selectCurrency': 'Seleziona valuta',
  'profile.paymentMethods.walletAddressPlaceholder': 'Indirizzo portafoglio',
  'profile.paymentMethods.accountNumberPlaceholder': 'Numero di conto',
  'profile.paymentMethods.bankNamePlaceholder': 'Nome banca',
  'profile.paymentMethods.accountHolderPlaceholder': 'Nome intestatario',
  'profile.paymentMethods.routingNumberPlaceholder': 'Numero di routing',
  'profile.paymentMethods.swiftCodePlaceholder': 'Codice SWIFT/BIC',
  'profile.referralLink.title': 'Il Mio Link di Referral',
  'profile.referralLink.description': 'Usa il tuo link di referenza per invitare familiari, amici e colleghi a unirsi a The Club. Quando si registrano utilizzando il tuo link, guadagnerai commissioni dai loro profitti secondo il tuo modello di commissioni.',
  'profile.referralLink.howToUse': 'Come usare il tuo link di referral:',
  'profile.referralLink.step1': 'Copia il tuo link unico di referral qui sotto',
  'profile.referralLink.step2': 'Condividilo con persone che conosci e che sono interessate a investire e trading',
  'profile.referralLink.step3': 'Quando si registrano usando il tuo link, entrano a far parte della tua community',
  'profile.referralLink.step4': 'Guadagna commissioni dai loro profitti in base alla tua struttura di commissioni',
  'profile.referralLink.yourLink': 'Il Tuo Link di Referral',
  'profile.referralLink.partnerLink': 'Link Referral Partner',
  'profile.referralLink.partnerDescription': 'Condividi questo link con persone che vogliono costruire la propria rete di referral. Erediteranno il tuo piano commissioni.',
  'profile.referralLink.clientLink': 'Link Referral Cliente',
  'profile.referralLink.clientDescription': 'Condividi questo link con persone che vogliono solo investire. Non avranno una rete di referral.',
  'profile.referralLink.notAvailable': 'I link di referral non sono disponibili per il tuo tipo di account.',
  'profile.referralLink.copyTooltip': 'Copiato negli appunti!',
  'profile.referralLink.copyReferralLink': 'Copia link di referral',
  'profile.referralLink.tipsForSuccessTitle': 'Consigli per il Successo:',
  'profile.referralLink.tipsForSuccessTip1': 'Condividi il tuo link con persone veramente interessate a investire e trading',
  'profile.referralLink.tipsForSuccessTip2': 'Spiega i vantaggi di entrare in The Club e come funzionano i nostri programmi di investimento',
  'profile.referralLink.tipsForSuccessTip3': 'Rimani disponibile per rispondere alle domande e fornire supporto ai tuoi referral',
  'profile.referralLink.tipsForSuccessTip4': 'Monitora i tuoi guadagni da commissioni nella sezione "I Miei Profitti"',
  'profile.common.loading': 'Caricamento...',
  'profile.common.error': 'Errore nel caricamento dati',
  'profile.common.noData': 'Nessun dato disponibile',
  'profile.common.updateSuccess': 'Informazioni aggiornate con successo',
  'profile.common.updateError': 'Errore nell\'aggiornamento delle informazioni',
  'profile.common.defaultUser': 'Utente',
  'profile.common.defaultUsername': 'nomeutente',
  'profile.common.userMustBeActive': 'L\'utente deve essere attivo',
  'profile.errorHandling.fillRequiredFields': 'Per favore compila tutti i campi obbligatori correttamente',
  'profile.validation.firstName': 'Nome',
  'profile.validation.lastName': 'Cognome',
  'profile.validation.country': 'Paese',
  'profile.validation.address': 'Indirizzo',
  'profile.validation.city': 'Città',
  'profile.validation.accountNumber': 'Numero di conto',
  'profile.validation.bankName': 'Nome banca',
  'profile.validation.accountHolderName': 'Nome intestatario',
  'profile.validation.routingNumber': 'Numero di routing',
  'profile.validation.swiftCode': 'Codice SWIFT',
  'profile.validation.required': 'è obbligatorio',
  'profile.validation.minLength': 'deve avere almeno {count} caratteri',
  'profile.validation.maxLength': 'non deve avere più di {count} caratteri',
  'profile.validation.nameFormat': 'può contenere solo lettere, spazi, trattini e apostrofi',
  'profile.validation.phoneFormat': 'Per favore inserisci un numero di telefono valido',
  'profile.validation.dateOfBirth': 'Deve essere una data valida ed età tra 18-100 anni',
  'profile.validation.postalCode': 'Per favore inserisci un codice postale valido',
  'profile.validation.minLengthAfterSanitization': 'deve avere almeno {count} caratteri dopo la sanificazione',
  'profile.validation.selectNetwork': 'Per favore seleziona una rete',
  'profile.validation.selectCurrency': 'Per favore seleziona una valuta',
  'profile.validation.walletAddressFormat': 'L\'indirizzo del portafoglio può contenere solo lettere e numeri',
  'profile.validation.accountNumberFormat': 'Il numero di conto deve contenere solo cifre',
  'profile.validation.bankNameFormat': 'Il nome della banca contiene caratteri non validi',
  'profile.validation.accountHolderFormat': 'Il nome dell\'intestatario può contenere solo lettere, spazi, trattini, apostrofi e punti',
  'profile.validation.routingNumberFormat': 'Il numero di routing deve avere esattamente 9 cifre',
  'profile.validation.swiftCodeFormat': 'Per favore inserisci un codice SWIFT/BIC valido',
  'profile.toast.error': 'Errore',
  'profile.toast.success': 'Successo',
  'profile.toast.validationError': 'Errore di Validazione',
};
